import { render, staticRenderFns } from "./OrdersReportsModal.vue?vue&type=template&id=9f0118f8&scoped=true"
import script from "./OrdersReportsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersReportsModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrdersReportsModal.vue?vue&type=style&index=0&id=9f0118f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0118f8",
  null
  
)

export default component.exports